export default "__VITE_ASSET__BDSIp0ZO__"